import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { connect } from 'react-redux';

import { Session, State } from '../state';

const SessionContext = createContext<Session>(undefined);

interface SessionProviderOwnProps {
    children?: ReactNode;
}

interface SessionProviderStateProps {
    session: Session;
}

type SessionProviderProps = SessionProviderOwnProps & SessionProviderStateProps;

const SessionProviderComp = ({ session, children }: SessionProviderProps): JSX.Element => {
    return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
};

const mapStateToProps = (state: State) => ({
    session: state.session
});

const SessionProvider = connect<SessionProviderStateProps, undefined, SessionProviderOwnProps, State>(mapStateToProps)(
    SessionProviderComp
);

const useSession = () => useContext(SessionContext);

export { SessionProvider, useSession };
